const dashboardLayoutStyle = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
      transition: theme.transitions.create('padding-left', {
        easing: theme.transitions.easing.sharp,
        duration: '0.1s',
      }),
      '&.wrapperWithSmallNabBar': {
        paddingLeft: 56,
      },
    }
  },
  // Column flex so the top-message bar is a sibling ABOVE the scrolling
  // content rather than a child inside it. See the topMessage comment below.
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    // Required. A flex child will not shrink below its content size without
    // it, so the scroller would either stop scrolling or overrun the
    // viewport once a banner is taking height above it. This is also the
    // safety net for the first paint, before the ResizeObserver in
    // DashboardLayout has published --cp-top-banner-height: the height below
    // still resolves to 100%, and shrinking brings it back to the real
    // available space on its own.
    minHeight: 0,
    // Kept as an explicit height (rather than letting flex size it) so
    // percentage heights inside pages -- Page's own minHeight: 100% -- go on
    // resolving exactly as they did before. With no banner showing the
    // variable is 0px and this is identical to the previous height: '100%'.
    height: 'calc(100% - var(--cp-top-banner-height, 0px))',
    overflow: 'auto'
  },
  // Page-level banners (import/revert progress, subscription warnings, port
  // status, send-hours) sit here, ABOVE the scrolling content container
  // rather than inside it, so they are visible at every scroll position
  // without ever overlaying the page.
  //
  // They used to render inside #firstContentScroll as a static block, which
  // meant they scrolled up under the fixed 64px AppBar and disappeared.
  // Commit 634ce9a9 (2026-08-13) fixed that with position: sticky, top: 0,
  // zIndex: 900 -- but a sticky element pins over whatever is beneath it, so
  // from that point on every banner covered the top of the page content at
  // any scrollTop > 0. On the Connections screen that was the chat toolbar's
  // kebab button; ChatView asks for calc(100vh - 88px) regardless of the
  // banner, so the banner's own height was the exact amount of scroll
  // overflow it created, and scrolling it put the banner over the toolbar.
  //
  // Hoisting the bar out of the scroller removes the overlap for all
  // banners, on every screen, including any added later, while keeping the
  // always-visible behaviour that commit was after. Nothing needs a z-index
  // because nothing is overlapping any more.
  //
  // DashboardLayout measures this element and publishes its rendered height
  // as --cp-top-banner-height for the few places that size themselves
  // against the viewport instead of their parent.
  topMessage: {
    flexShrink: 0,
  }
});

export default dashboardLayoutStyle;
